export const PRINT_STATIONS = [
  { id: "kitchen", label: "Cucina", aliases: ["kitchen", "cucina"] },
  { id: "pizzeria", label: "Pizzeria", aliases: ["pizzeria", "pizza"] },
  { id: "bar", label: "Bar", aliases: ["bar", "caffe", "caffè"] },
];

export const COURSE_OPTIONS = [
  { id: "", label: "Nessun turno" },
  { id: "1", label: "Turno 1" },
  { id: "2", label: "Turno 2" },
  { id: "3", label: "Turno 3" },
  { id: "antipasti", label: "Antipasti" },
  { id: "primi", label: "Primi" },
  { id: "secondi", label: "Secondi" },
];

export function stationLabel(id) {
  const s = PRINT_STATIONS.find((x) => x.id === id || x.aliases.includes(String(id || "").toLowerCase()));
  if (s) return s.label;
  return id ? String(id) : "";
}

export function courseLabel(id) {
  if (!id) return "";
  return COURSE_OPTIONS.find((c) => c.id === String(id))?.label || String(id);
}

export function groupLinesByCourse(lines) {
  const list = Array.isArray(lines) ? lines : [];
  const has = list.some((l) => l?.course);
  if (!has) {
    return [{ key: "_", label: null, items: list.map((line, index) => ({ line, index })) }];
  }
  const order = COURSE_OPTIONS.map((c) => c.id).filter(Boolean);
  const buckets = new Map();
  list.forEach((line, index) => {
    const k = line.course || "_none";
    if (!buckets.has(k)) buckets.set(k, []);
    buckets.get(k).push({ line, index });
  });
  const keys = [...buckets.keys()].sort((a, b) => {
    if (a === "_none") return 1;
    if (b === "_none") return -1;
    const ia = order.indexOf(a);
    const ib = order.indexOf(b);
    return (ia < 0 ? 99 : ia) - (ib < 0 ? 99 : ib);
  });
  return keys.map((key) => ({
    key,
    label: key === "_none" ? "Senza turno" : courseLabel(key),
    items: buckets.get(key),
  }));
}
